import { useEffect } from "react";
import { useRecordContext } from "react-admin";
import { useTheme } from "@mui/material";

/**
 * Side effect: Updates the document title (i.e. the title of the browser tab).
 */
export function NameHeader({ children }: { children: string }) {
  const theme = useTheme();
  useEffect(() => {
    document.title = children;
  }, []);
  const record = useRecordContext();
  const deletedOrDisabledOrInactiveOrArchived =
    record?.deleted ||
    record?.disabled ||
    record?.archived ||
    (typeof record?.isActive === "boolean" && !record.isActive);

  return (
    <h2
      style={{
        margin: 0,
        fontWeight: 600,
        lineHeight: 1.08,
        color: deletedOrDisabledOrInactiveOrArchived ? theme.palette.text.disabled : undefined,
      }}
    >
      {children}
    </h2>
  );
}
